var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 324,
    height: 101,
    viewBox: "0 0 324 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 324,
    height: 101,
    transform: "translate(8069 -2512)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M0-816H500v303.571H0Z",
    transform: "translate(0 815.998)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(-8069 2512)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(7983 -1799.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(0 -815.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(314.099 107.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M-143.961-131.1a8.612,8.612,0,0,1-8.6,8.627h-68.089a8.612,8.612,0,0,1-8.6-8.627v-69.041a8.612,8.612,0,0,1,8.6-8.627h68.089a8.612,8.612,0,0,1,8.6,8.627Z",
    transform: "translate(229.246 208.77)",
    fill: "#069"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(95.88 125.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M0,0H11.474V41.217H31.7V50.88H0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M353.388-469.361h11.475v36.914H353.388Zm11.851-10.266c0,3.17-2.34,5.737-6.19,5.737a5.654,5.654,0,0,1-5.964-5.737c0-3.246,2.416-5.737,6.115-5.737a5.674,5.674,0,0,1,6.038,5.737",
    transform: "translate(-221.729 608.368)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(149.698 138.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M-.509-21.28c0-4.6-.151-8.453-.3-11.776H9.153l.529,5.133h.227a13.255,13.255,0,0,1,11.4-5.964c7.55,0,13.212,5.059,13.212,15.929V3.858H23.044V-16.6c0-4.755-1.66-8-5.812-8a6.3,6.3,0,0,0-5.889,4.3,8.273,8.273,0,0,0-.376,2.869V3.858H-.509Z",
    transform: "translate(0.811 33.887)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(191.893 122.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M-19.369-54.409h.151a49.641,49.641,0,0,1,2.642-4.453L-9.1-69.96H4.711L-8.5-55.013,6.6-33.046H-7.518L-16.5-48.219-19.369-44.6v11.55H-30.844v-53.6h11.475Z",
    transform: "translate(30.844 86.642)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(227.296 138.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M-41.286-25.485c0-2.793-1.207-7.473-6.492-7.473-4.831,0-6.795,4.455-7.1,7.473ZM-54.8-17.634c.3,4.755,5.057,7.02,10.417,7.02A30.426,30.426,0,0,0-34.188-12.2l1.509,7.775A34.9,34.9,0,0,1-46.04-2.083c-12.532,0-19.7-7.247-19.7-18.8,0-9.36,5.813-19.7,18.645-19.7,11.928,0,16.457,9.286,16.457,18.42a27.273,27.273,0,0,1-.378,4.529Z",
    transform: "translate(65.744 40.583)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(264.81 122.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M-44.6-54.538a10.308,10.308,0,0,0-.151-2.115,6.9,6.9,0,0,0-6.717-5.585c-5.285,0-7.928,4.68-7.928,10.493,0,6.264,3.1,10.19,7.852,10.19a6.8,6.8,0,0,0,6.718-5.51,14.889,14.889,0,0,0,.226-2.642Zm11.475-32.31v42.575c0,4.151.151,8.531.3,11.021H-43.014l-.452-5.36h-.226c-2.265,4.076-6.795,6.191-11.55,6.191-8.756,0-15.777-7.474-15.777-18.948-.075-12.456,7.7-19.7,16.532-19.7,4.605,0,8.077,1.661,9.738,4.152h.151V-86.848Z",
    transform: "translate(71.02 86.848)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M886.505-469.361h11.474v36.914H886.505Zm11.851-10.266c0,3.17-2.34,5.737-6.19,5.737a5.653,5.653,0,0,1-5.963-5.737c0-3.246,2.415-5.737,6.114-5.737a5.674,5.674,0,0,1,6.039,5.737",
    transform: "translate(-556.514 608.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(348.031 138.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M-.508-21.28c0-4.6-.151-8.453-.3-11.776H9.154l.529,5.133h.226a13.256,13.256,0,0,1,11.4-5.964c7.549,0,13.21,5.059,13.21,15.929V3.858H23.044V-16.6c0-4.755-1.661-8-5.813-8a6.3,6.3,0,0,0-5.887,4.3,8.258,8.258,0,0,0-.378,2.869V3.858H-.508Z",
    transform: "translate(0.809 33.887)",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.14686fd942c46862e26a7750b4cc00fe.svg";
export { ForwardRef as ReactComponent };